// extracted by mini-css-extract-plugin
export default {"input-suffix":"ElectricityPriceManage_input-suffix__TouNq","wrapperPadding":"ElectricityPriceManage_wrapperPadding__MpOz6"};